import React from 'react';
import PropTypes from 'prop-types';
import MotiveDesktop from './MotiveDesktop';
import MotiveMobile from './MotiveMobile';

const Motive = ({ ...props }) => {
  const { mobile, motives, issueId } = props;

  return (
    <React.Fragment>
      {!mobile && <MotiveDesktop motives={motives} />}
      {mobile && <MotiveMobile motives={motives} issueId={issueId} />}
    </React.Fragment>
  );
};

Motive.propTypes = {
  mobile: PropTypes.bool,
  motives: PropTypes.array,
  issueId: PropTypes.string,
};

export default Motive;
